import Placement from "./Placement";

class Nature extends Placement {
  CONGRATULATION = 'нашёл все объекты в игре';
  CONGRATULATION_PLURAL = 'нашли все объекты в игре';
  HEADER = 'Природа'
  CAPTION = 'Найдите природный объект на карте.'
}

export default Nature;
